import { render, staticRenderFns } from "./SfPrice.vue?vue&type=template&id=d4a4e422&functional=true&"
import script from "./SfPrice.vue?vue&type=script&lang=ts&"
export * from "./SfPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports